import React, { FC } from 'react';
import { AntDesign } from '@expo/vector-icons';
import { ParagraphLBold } from '../../config/designSystem/typography';
import { StyleSheet, View } from 'react-native';
import { concatPath } from '../../utils/links/concatPath';
import { dashboardStackKey } from '../../constants/routeKeys';
import { router } from 'expo-router';



type Props = {
  title: string;
  color?: string;
}


const WebHeader: FC<Props> = ({ title, color }) => {

  const goToHome = () => {

    router.navigate(concatPath([dashboardStackKey ], 2) as string);
  };


  return (
    <View>
      <View style={{ backgroundColor: color }}>
        <View style={styles.container}>
          <AntDesign
            style={styles.icon}
            name="left" size={20}
            color="black"
            onPress={() => {
              if (router.canGoBack()) {
                router.back();
              } else {
                goToHome();
              }
            }}
          />
          <View style={{ justifyContent: 'center', alignItems: 'center', flex: 1 }}>
            <ParagraphLBold>
              {title}
            </ParagraphLBold>
          </View>
        </View>
      </View>
    </View>
  );
};



export default WebHeader;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    padding: 20,
    borderBottomWidth: 1.4,
    borderBottomColor: '#cccccc7d',
  },

  icon: {
    position: 'absolute',
    zIndex: 1
  }
});




